import { z } from 'zod';

export type PriceSchemaRules = {
    allowNegative?: boolean;
    minValue?: number;
    errorMessages?: {
        required?: string;
        multipleOf?: string;
        minValue?: string;
        nonNegative?: string;
    };
};

export const PriceSchema = (params?: PriceSchemaRules) => {
    const { allowNegative = true, minValue, errorMessages } = params ?? {};

    let BasePriceSchema = z
        .number({
            required_error: errorMessages?.required,
            invalid_type_error: errorMessages?.required,
        })
        .multipleOf(0.01, {
            message: errorMessages?.multipleOf,
        });

    if (typeof minValue === 'number') {
        BasePriceSchema = BasePriceSchema.min(minValue, {
            message: errorMessages?.minValue,
        });
    }

    if (!allowNegative) {
        BasePriceSchema = BasePriceSchema.nonnegative({
            message: errorMessages?.nonNegative,
        });
    }

    return BasePriceSchema;
};
